import React, { useEffect, useState } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Button } from "src/components/common"
import { track } from "src/utils/track"
import { scrollToAnchor } from "src/utils/scroll"
import { Bar } from "./styles"

// Mobile-only bottom bar that appears once the hero CTA has scrolled out of
// view and hides again while the contact section or the footer is visible.
export const StickyCta = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window))
      return undefined
    const heroCta = document.getElementById("hero-cta")
    const contact = document.getElementById("contact")
    const footer = document.querySelector("footer")
    if (!heroCta || !contact) return undefined

    const state = { heroCta: true, contact: false, footer: false }
    const update = () =>
      setVisible(!state.heroCta && !state.contact && !state.footer)
    const observe = (element, key, options) => {
      if (!element) return null
      const observer = new IntersectionObserver(entries => {
        state[key] = entries[0].isIntersecting
        update()
      }, options)
      observer.observe(element)
      return observer
    }

    const observers = [
      observe(heroCta, "heroCta", { threshold: 0 }),
      observe(contact, "contact", { threshold: 0.15 }),
      observe(footer, "footer", { threshold: 0 }),
    ]
    return () =>
      observers.forEach(observer => observer && observer.disconnect())
  }, [])

  return (
    <Bar $visible={visible} aria-hidden={!visible}>
      <Button
        href="#contact"
        tabIndex={visible ? 0 : -1}
        onClick={event => {
          track("cta_click", { location: "sticky-mobile" })
          scrollToAnchor(event)
        }}
      >
        {t("nav_cta")}
      </Button>
    </Bar>
  )
}
